import CityPageTemplate from "../city-template/CityPageTemplate";
import { marionConfig } from "./data";

export default function MarionPage() {
  return <CityPageTemplate config={marionConfig} />;
}